import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Contract } from '../model/contract';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from './../../environments/environment';
import * as firebase from 'firebase';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {


  @Input()
  contract: Contract;


  @Input()
  isContractValid: boolean;


  @Input()
  validateContract: Function;


  @Output()
  onSave: EventEmitter<any> = new EventEmitter();


  @Output()
  onPdfExport: EventEmitter<any> = new EventEmitter();

  @Output()
  onWordExport: EventEmitter<any> = new EventEmitter();

  @Output()
  onWordToPdfExport: EventEmitter<any> = new EventEmitter();

  modalRef: BsModalRef;
  userlogged: boolean = false;




  @ViewChild('legendModalTemplate')
  private legendModalTemplate: TemplateRef<any>;


  public unsavedWarning = `<strong>Upozorenje!</strong>Dokument nije do kraja ispunjen ili sadrži greške. Crvenom bojom odnosno naznakom “polje je obavezno” su označeni dijelovi dokumenta koje treba ispuniti odnosno prepraviti. Dokument je spremljen, a preuzimanje u PDF formatu će biti moguće tek nakon izmjena ili preinaka.`;
  public logiransam: boolean = false;
  useremail: string = '';
  constructor(private spinner: NgxSpinnerService, private router: Router, private route: ActivatedRoute, private modalService: BsModalService) { }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
       /** spinner starts on init */
      //  this.spinner.show();

      //   setTimeout(() => {
      // /** spinner ends after 5 seconds */
      //   this.spinner.hide();
      //  }, 5000);

      //  addEventListener("exportAsWord; exportAsWordToPdf", () => {
      //   (<any>window).spinner.hide();
      //  });

        // setTimeout(() => {
        //   (<any>window).spinner.hide();
        // }, 2000);;

    //     this.spinner.hide = this.spinner.hide;
    // if ( this.onWordExport && this.onWordToPdfExport) {
    //   true;
    // }

        
        
       

    if(environment.production) {

      // this.isContractValid = false;
      firebase.auth().onAuthStateChanged(user => {
        if (!user) {
          console.log('logout onAuthStateChanged', user);
          this.logiransam = false;
          this.useremail = '';
          console.log('this.logiransam', this.logiransam);
          // OVDJE IDE REDIREKCIJA NA ROOT kk
          console.log('kkkkkk');

          this.router.navigate(['/']);
        }
        else {
          console.log('login onAuthStateChanged', user);
          this.logiransam = true;
          this.useremail = user.email;
          console.log('this.logiransam', this.logiransam);

        }
      });

    } else {
      // Local env
      
      this.logiransam = true;
      this.useremail = 'development@selflegal.local';
    }

  }

  save(errorModal, successModal): void {
    let contractValid = this.validateContract(this.contract);
    let validOIB = (contract) => {
      let valid = true;
      contract.sides.map(e => {
        e.inputs.map(input => {
          if (input.placeholder === 'OIB') {
            if (typeof input.value != 'number' && input.value.length !== 11) {
              valid = false;
            }
          }
        });
      });
      return valid;
    };
    if (contractValid && validOIB(this.contract)) {
      this.modalRef = this.modalService.show(successModal);
    }
    else {
      this.modalRef = this.modalService.show(errorModal);
    }
    this.onSave.emit();
  }


  logout() {

    console.log('signOut ...');
    firebase.auth().signOut();
    //firebase.database().ref('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, '')).remove();
  }

  exportAsPdf(): void {
    this.onPdfExport.emit();
  }

  exportAsWord(): void {
    this.onWordExport.emit();
  }

  exportAsWordToPdf(): void {
    this.onWordToPdfExport.emit();
  }

  showHelp(): void {
    this.modalRef = this.modalService.show(this.legendModalTemplate);
  }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/navbar/navbar.component.ts